import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as PaymentService from 'services/sales/payment';

export const usePaymentService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createPayment = async (options = {}) => {
    const { error, payload } = await PaymentService.create({ ...options, token });
    if (error) {
      toast.error('Could not initialize payment.');
      return null;
    }

    return payload;
  };

  const fetchPayments = async (options = {}) => {
    const { error, payload } = await PaymentService.read({ ...options, token });
    if (error) {
      return { payments: [], size: 0 };
    }

    const {
      data: payments,
      meta: { size }
    } = payload;
    return { payments, size };
  };

  const sendTopUpNotification = async (options = {}) => {
    const { error, payload } = await PaymentService.sendNotice({ ...options, token });
    if (error) {
      toast.error('An error occurred. Please try again.');
    } else {
      toast.success('Your wallet will be credited shortly.');
    }

    return payload;
  };

  const verifyPayment = async (options = {}) => {
    const { error, payload } = await PaymentService.verify({ ...options, token });
    if (error) {
      toast.error(error);
      return null;
    }

    return payload;
  };

  return { sendTopUpNotification, verifyPayment, createPayment, fetchPayments };
};
